import React from 'react';
import { ConfigProvider } from 'antd';

/**
 * The form's actions again, at the END of the form flow. A long record form
 * keeps its primary in the sticky context bar; by the time you reach the
 * last field the bar is a scroll away, so the same buttons close the main
 * column too.
 *
 * The caller defines its action buttons ONCE and renders that node in both
 * places, so the two never drift:
 *
 *   const formActions = readOnly ? null : (<><Button>Cancel</Button><Button type="primary">Save</Button></>);
 *   <ContextBar actions={<>{draftNote}{formActions}{kebab}</>} />
 *   ...
 *   <FormActionsFooter>{formActions}</FormActionsFooter>
 *
 * The footer carries the primary and the labeled secondaries only — the ⋯
 * menu and status text ("Draft saved", "No changes") stay in the bar. With
 * nothing to show (read-only, locked) it renders nothing.
 *
 * The footer sits INSIDE the form's main column, which on some forms is an
 * antd <Form disabled> — that would grey a Cancel the bar shows live. The
 * buttons state their own disabled/loading props, so the enclosing form's
 * disabled context is switched off here and the two copies match exactly.
 */
export default function FormActionsFooter({ children, className = '', ...rest }) {
	if (!children) return null;
	const classes = ['form-actions-footer', className].filter(Boolean).join(' ');
	return (
		<div className={classes} data-testid="form-actions-footer" {...rest}>
			<ConfigProvider componentDisabled={false}>
				{children}
			</ConfigProvider>
		</div>
	);
}
